import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
};

/** account */
export type Account = {
  __typename?: 'Account';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account type */
  accountType: AccountType;
  /** Age range */
  ageRange: AgeRange;
  /** Alternative languages */
  alternativeLanguages: Array<Scalars['String']['output']>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Device Ids */
  deviceIds: Array<Scalars['String']['output']>;
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Email */
  email: Scalars['String']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Gender */
  gender: Gender;
  /** Is Test Account */
  isTestAccount: Scalars['Boolean']['output'];
  /** Last active at */
  lastActiveAt: Scalars['Timestamp']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Login name */
  loginName: Scalars['String']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Password type */
  passwordType: PasswordType;
  /** Preferred language */
  preferredLanguage: Scalars['String']['output'];
  /** Score */
  score: Scores;
  /** SelfReport ids */
  selfReportIds: Array<Scalars['ID']['output']>;
  /** SelfReports */
  selfReports: Array<SelfReport>;
  /** Url */
  url: Scalars['String']['output'];
};

/** account and new highscore */
export type AccountNewHighscore = {
  __typename?: 'AccountNewHighscore';
  /** Artefact */
  account: Account;
  /** NewHighScore */
  newHighScore: NewHighScore;
};

export type AccountQuery = {
  /** Account types */
  accountTypes?: InputMaybe<Array<AccountType>>;
  /** Disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AccountType {
  Administrator = 'Administrator',
  Participant = 'Participant',
  ProjectMember = 'ProjectMember'
}

export enum ActionApp {
  Booster = 'Booster',
  Chaser = 'Chaser',
  DigitalToolboxManager = 'DigitalToolboxManager',
  Server = 'Server'
}

export enum ActionVerb {
  Add = 'Add',
  Change = 'Change',
  Clear = 'Clear',
  Create = 'Create',
  Delete = 'Delete',
  Disable = 'Disable',
  Duplicate = 'Duplicate',
  Enable = 'Enable',
  Error = 'Error',
  Login = 'Login',
  Logout = 'Logout',
  MoveToTrash = 'MoveToTrash',
  Navigate = 'Navigate',
  QrCode = 'QrCode',
  Read = 'Read',
  Register = 'Register',
  Remove = 'Remove',
  Reorder = 'Reorder',
  RetrieveFromTrash = 'RetrieveFromTrash',
  Update = 'Update'
}

export type ActivityStreamObject = {
  __typename?: 'ActivityStreamObject';
  /** Actor */
  actor: Actor;
  /** App sequence number */
  appSequenceNumber: Scalars['Int']['output'];
  /** Generator */
  generator: Generator;
  /** Object */
  object: NextlabVerbs;
  /** Provider */
  provider: Provider;
  /** Published client date */
  published?: Maybe<Scalars['Timestamp']['output']>;
  /** Published server date */
  publishedServer?: Maybe<Scalars['Timestamp']['output']>;
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target */
  target: Target;
  /** Verb */
  verb: NextlabVerbs;
};

export type Actor = {
  __typename?: 'Actor';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
};

export type ActorInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
};

export type AddLogActionInput = {
  /** Actor id */
  actorId: Scalars['ID']['input'];
  /** Action location */
  app: ActionApp;
  /** Created at */
  clientDate: Scalars['Timestamp']['input'];
  /** Description of action */
  description: Scalars['JSON']['input'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['input'];
  /** Target id */
  targetId: Scalars['ID']['input'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type AddMembersToScienceOrganisationInput = {
  /** New member ids */
  newMemberIds: Array<Scalars['ID']['input']>;
};

/** address */
export type Address = {
  __typename?: 'Address';
  /** City */
  city: Scalars['String']['output'];
  /** Country */
  country: Scalars['String']['output'];
  /** House number */
  houseNumber: Scalars['String']['output'];
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street */
  street: Scalars['String']['output'];
  /** Zip code */
  zipCode: Scalars['String']['output'];
};

export type AddressDto = {
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** House number */
  houseNumber: Scalars['String']['input'];
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Zip code */
  zipCode: Scalars['String']['input'];
};

export enum AgeRange {
  Range06_08 = 'Range06_08',
  Range09_12 = 'Range09_12',
  Range13_15 = 'Range13_15',
  Range16_18 = 'Range16_18',
  Range18Plus = 'Range18Plus'
}

export type AppInfo = {
  __typename?: 'AppInfo';
  /** App type */
  appType: Scalars['String']['output'];
  /** Configuration */
  configuration?: Maybe<ResourceJson>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Item type */
  itemType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact */
export type Artefact = {
  __typename?: 'Artefact';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** Child artefact ids */
  childArtefactIds: Array<Scalars['ID']['output']>;
  /** Child artefacts */
  childArtefacts: Array<Artefact>;
  /** Content element ids */
  contentElementIds: Array<Scalars['ID']['output']>;
  /** Content element ids with warnings */
  contentElementIdsWithWarnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Content elements */
  contentElements: Array<ContentElement>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Domains */
  domains: Array<Domain>;
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Parent artefact */
  parentArtefact?: Maybe<Artefact>;
  /** Parent artefact id */
  parentArtefactId?: Maybe<Scalars['ID']['output']>;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact-route */
export type ArtefactRoute = {
  __typename?: 'ArtefactRoute';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['output']>;
  /** Artefacts */
  artefacts: Array<Artefact>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** artefact route and science organisation */
export type ArtefactRouteScienceOrganisation = {
  __typename?: 'ArtefactRouteScienceOrganisation';
  /** ArtefactRoute */
  artefactRoute: ArtefactRoute;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
};

/** artefact and science organisation */
export type ArtefactScienceOrganisation = {
  __typename?: 'ArtefactScienceOrganisation';
  /** Artefact */
  artefact: Artefact;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
};

/** change log */
export type ChangeLog = {
  __typename?: 'ChangeLog';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Applied at */
  appliedAt: Scalars['Timestamp']['output'];
  /** Migration file name */
  fileName: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  /** Confirm password */
  confirmPassword: Scalars['String']['input'];
  /** New password */
  newPassword: Scalars['String']['input'];
  /** Old password */
  oldPassword: Scalars['String']['input'];
};

/** content element and artefact */
export type ChildArtefactArtefact = {
  __typename?: 'ChildArtefactArtefact';
  /** Artefact */
  artefact: Artefact;
  /** Child artefact */
  childArtefact: Artefact;
};

export type CollectionIndices = {
  __typename?: 'CollectionIndices';
  /** Indices */
  indices: Array<IndexDefinition2>;
  /** Name */
  name: Scalars['String']['output'];
};

export type CollectionOverview = {
  __typename?: 'CollectionOverview';
  /** Total number of bytes */
  bytes?: Maybe<Scalars['Int']['output']>;
  /** Total number of kilobytes */
  kilobytes?: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Nr of disabled objects */
  nrOfDisabledObjects: Scalars['Int']['output'];
  /** Nr of enabled objects */
  nrOfEnabledObjects: Scalars['Int']['output'];
  /** Nr of not trashed objects */
  nrOfNotTrashedObjects: Scalars['Int']['output'];
  /** Nr of objects */
  nrOfObjects: Scalars['Int']['output'];
  /** Nr of trashed objects */
  nrOfTrashedObjects: Scalars['Int']['output'];
  /** Nr of usable objects */
  nrOfUsableObjects: Scalars['Int']['output'];
};

/** contentElement */
export type ContentElement = {
  __typename?: 'ContentElement';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** At Home */
  atHome?: Maybe<Scalars['Boolean']['output']>;
  /** Configuration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Content id */
  contentId: Scalars['String']['output'];
  /** Content plugin */
  contentPlugin: ContentPlugin;
  /** Content plugin id */
  contentPluginId: Scalars['ID']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** During visit */
  duringVisit?: Maybe<Scalars['Boolean']['output']>;
  /** Feedback body */
  feedbackBody?: Maybe<Scalars['String']['output']>;
  /** Feedback title */
  feedbackTitle?: Maybe<Scalars['String']['output']>;
  /** Language */
  language: Scalars['String']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Self report type */
  selfReportType?: Maybe<SelfReportType>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

/** content element and artefact */
export type ContentElementArtefact = {
  __typename?: 'ContentElementArtefact';
  /** Artefact */
  artefact: Artefact;
  /** Content Element */
  contentElement: ContentElement;
};

/** contentElementState */
export type ContentElementState = {
  __typename?: 'ContentElementState';
  /** Content element */
  contentElement: ContentElement;
  /** Content state */
  contentState?: Maybe<ContentState>;
};

/** contentPlugin */
export type ContentPlugin = {
  __typename?: 'ContentPlugin';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Application name */
  applicationName: Scalars['String']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Editor url */
  editorUrl: Scalars['String']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Resource type */
  resourceType: Scalars['String']['output'];
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
  /** Use in chaser */
  useInChaser: Scalars['Boolean']['output'];
  /** Use in results */
  useInResults: Scalars['Boolean']['output'];
  /** Viewer url */
  viewerUrl: Scalars['String']['output'];
};

/** contentState */
export type ContentState = {
  __typename?: 'ContentState';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account id */
  accountId: Scalars['ID']['output'];
  /** Content element */
  contentElement: ContentElement;
  /** Content element id */
  contentElementId: Scalars['ID']['output'];
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['JSON']['output']>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
};

export type CreateAccountInput = {
  /** Accepted legal terms */
  acceptedLegalTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account type */
  accountType: AccountType;
  /** Age range */
  ageRange: AgeRange;
  /** Alternative languages */
  alternativeLanguages: Array<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Gender */
  gender: Gender;
  /** Is test account */
  isTestAccount: Scalars['Boolean']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Login name */
  loginName: Scalars['String']['input'];
  /** Password */
  password: Scalars['String']['input'];
  /** Password type */
  passwordType: PasswordType;
  /** Preferred language */
  preferredLanguage: Scalars['String']['input'];
  /** Should change password */
  shouldChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateArtefactInput = {
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** Child artefact ids */
  childArtefactIds: Array<Scalars['ID']['input']>;
  /** Content element ids */
  contentElementIds: Array<Scalars['ID']['input']>;
  /** Domains */
  domains: Array<Domain>;
  /** Parent artefact id */
  parentArtefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
};

export type CreateArtefactRouteInput = {
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
};

export type CreateContentElementInput = {
  /** Age ranges */
  ageRanges: Array<AgeRange>;
  /** At Home */
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Content id */
  contentId: Scalars['String']['input'];
  /** Content plugin id */
  contentPluginId: Scalars['ID']['input'];
  /** Description */
  description: Scalars['String']['input'];
  /** During visit */
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feedback body */
  feedbackBody?: InputMaybe<Scalars['String']['input']>;
  /** Feedback title */
  feedbackTitle?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  language: Scalars['String']['input'];
  /** Self report type */
  selfReportType?: InputMaybe<SelfReportType>;
  /** Title */
  title: Scalars['String']['input'];
};

export type CreateContentPluginInput = {
  /** Application name */
  applicationName: Scalars['String']['input'];
  /** Editor url */
  editorUrl: Scalars['String']['input'];
  /** Resource type */
  resourceType: Scalars['String']['input'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
  /** Use in chaser */
  useInChaser: Scalars['Boolean']['input'];
  /** Use in results */
  useInResults: Scalars['Boolean']['input'];
  /** Viewer url */
  viewerUrl: Scalars['String']['input'];
};

export type CreateContentStateInput = {
  /** Account id */
  accountId: Scalars['ID']['input'];
  /** Content element id */
  contentElementId: Scalars['ID']['input'];
  /** State */
  state?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateQrCodeInput = {
  /** Target Id */
  targetId: Scalars['ID']['input'];
  /** Target type */
  targetType: QrCodeTargetType;
};

export type CreateScienceOrganisationInput = {
  /** Location */
  location: LocationDto;
  /** Logo url */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Member ids */
  memberIds: Array<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescriptionDto>;
  /** Website url */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSelfReportInput = {
  /** content element id */
  contentElementId?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the report */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Url of the material */
  materialUrl?: InputMaybe<Scalars['String']['input']>;
  /** Strands */
  strands: StrandsInput;
  /** Title of the report */
  title: Scalars['String']['input'];
  /** Type of the report */
  type: SelfReportType;
};

export enum Domain {
  Astronomy = 'Astronomy',
  Biology = 'Biology',
  Chemistry = 'Chemistry',
  Engineering = 'Engineering',
  Mathematics = 'Mathematics',
  Physics = 'Physics',
  Programming = 'Programming'
}

export type EnableNotificationDto = {
  /** Device ID */
  deviceId: Scalars['String']['input'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  PreferNotToSay = 'PreferNotToSay'
}

export type Generator = {
  __typename?: 'Generator';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

export type GeneratorInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
  /** Url */
  url: Scalars['String']['input'];
};

/**  gps location */
export type GpsLocation = {
  __typename?: 'GpsLocation';
  /** Latitude */
  latitude: Scalars['String']['output'];
  /** Longitude */
  longitude: Scalars['String']['output'];
};

export type GpsLocationDto = {
  /** Latitude */
  latitude: Scalars['String']['input'];
  /** Longitude */
  longitude: Scalars['String']['input'];
};

/** High score entry */
export type HighScoreEntry = {
  __typename?: 'HighScoreEntry';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Current streak */
  currentStreak: Scalars['Int']['output'];
  /** Login name */
  loginName: Scalars['String']['output'];
  /** Longest streak */
  longestStreak: Scalars['Int']['output'];
  /** Total score */
  totalScore: Scalars['Int']['output'];
};

export type IlsStructure = {
  __typename?: 'IlsStructure';
  /** List of global apps */
  apps: Array<AppInfo>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['output'];
  /** Ils id */
  ilsId: Scalars['String']['output'];
  /** Can be run offline */
  offlineSupport: Scalars['Boolean']['output'];
  /** List of phases */
  phases: Array<PhaseStructure>;
  /** Url */
  url: Scalars['String']['output'];
};

export type IlsStructureJson = {
  __typename?: 'IlsStructureJson';
  /** ILS structure */
  ilsStructure: Scalars['JSON']['output'];
};

export type IndexDefinition2 = {
  __typename?: 'IndexDefinition2';
  /** Fields */
  fields: Array<KeyValue>;
  /** Options */
  options: Array<KeyValue>;
};

/** Key with count */
export type KeyCount = {
  __typename?: 'KeyCount';
  /** Count */
  count: Scalars['Int']['output'];
  /** Key */
  key: Scalars['String']['output'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  /** Key */
  key: Scalars['String']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** location */
export type Location = {
  __typename?: 'Location';
  /** address */
  address?: Maybe<Address>;
  /** gps location */
  gpsLocation?: Maybe<GpsLocation>;
  /** Location type */
  locationType: LocationType;
};

export type LocationDto = {
  /** address */
  address?: InputMaybe<AddressDto>;
  /** gps location */
  gpsLocation?: InputMaybe<GpsLocationDto>;
  /** Location type */
  locationType: LocationType;
};

export enum LocationType {
  Address = 'Address',
  Home = 'Home',
  Outdoor = 'Outdoor',
  School = 'School',
  ScienceOrganisation = 'ScienceOrganisation'
}

export type LogAccessorQueryResultJson = {
  __typename?: 'LogAccessorQueryResultJson';
  /** log accessor query results */
  logAccessorQueryResults: Scalars['JSON']['output'];
};

/** log action */
export type LogAction = {
  __typename?: 'LogAction';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Creator */
  actor: Account;
  /** Actor id */
  actorId: Scalars['ID']['output'];
  /** Action location */
  app: ActionApp;
  /** Client date */
  clientDate: Scalars['Timestamp']['output'];
  /** Description of action */
  description?: Maybe<Scalars['JSON']['output']>;
  /** Server date */
  serverDate: Scalars['Timestamp']['output'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target id */
  targetId: Scalars['ID']['output'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type LogActionActorQueryInput = {
  /** Actor ids */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Object type */
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionBasicProjectionInput = {
  /** Display name */
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionGeneratorProjectionInput = {
  /** Display name */
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionGeneratorQueryInput = {
  /** Generator ids */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Log action key counts */
export type LogActionKeyCounts = {
  __typename?: 'LogActionKeyCounts';
  /** Nr of log action summaries per action app */
  nrsPerActionApp: Array<KeyCount>;
  /** Nr of log action summaries per action verb */
  nrsPerActionVerb: Array<KeyCount>;
  /** Nr of log action summaries per science organisation id */
  nrsPerScienceOrganisationId: Array<KeyCount>;
  /** Nr of log action summaries per target type */
  nrsPerTargetType: Array<KeyCount>;
  /** Total nr of log action summaries */
  totalNr: Scalars['Int']['output'];
};

export type LogActionObjectProjectionInput = {
  /** Content */
  content?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object type */
  objectType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionObjectTypeQueryInput = {
  /** Object type */
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionProjectionJsonInput = {
  /** Actor projections */
  actor?: InputMaybe<LogActionBasicProjectionInput>;
  /** All actor fields */
  actorAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** App sequence number */
  appSequenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Generator projections */
  generator?: InputMaybe<LogActionGeneratorProjectionInput>;
  /** All generator fields */
  generatorAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Object projections */
  object?: InputMaybe<LogActionObjectProjectionInput>;
  /** All object fields */
  objectAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider projections */
  provider?: InputMaybe<LogActionProviderProjectionInput>;
  /** All provider fields */
  providerAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client time */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server time */
  publishedServer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Session sequence number */
  sessionSequenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target projections */
  target?: InputMaybe<LogActionBasicProjectionInput>;
  /** All target fields */
  targetAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Verb */
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionProviderProjectionInput = {
  /** ILS has angela */
  ilsHasAngeLA?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry phase */
  inquiryPhase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry id */
  inquiryPhaseId?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inquiry name */
  inquiryPhaseName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogActionProviderQueryInput = {
  /** Phase ids */
  inquiryPhaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogActionQuery = {
  /** Action apps */
  actionApps?: InputMaybe<Array<ActionApp>>;
  /** Action verbs */
  actionVerbs?: InputMaybe<Array<ActionVerb>>;
  /** End date */
  endDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Science organisation ids */
  scienceOrganisationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Target types */
  targetTypes?: InputMaybe<Array<TargetTypes>>;
};

export type LogActionQueryJsonInput = {
  /** Actor query */
  actor?: InputMaybe<LogActionActorQueryInput>;
  /** Generator query */
  generator?: InputMaybe<LogActionGeneratorQueryInput>;
  /** max nr of results */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** Object query */
  object?: InputMaybe<LogActionObjectTypeQueryInput>;
  /** page number */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Provider query */
  provider?: InputMaybe<LogActionProviderQueryInput>;
  /** Client time */
  published?: InputMaybe<LogActionTimeQueryInput>;
  /** Server time */
  publishedServer?: InputMaybe<LogActionTimeQueryInput>;
  /** Target query */
  target?: InputMaybe<LogActionObjectTypeQueryInput>;
  /** Verbs */
  verbs?: InputMaybe<Array<NextlabVerbs>>;
};

/** Log action summaries */
export type LogActionSummaries = {
  __typename?: 'LogActionSummaries';
  /** Log action summaries */
  logActionSummaries: Array<LogActionSummary>;
  /** Nr of log action summaries per action app */
  nrsPerActionApp: Array<KeyCount>;
  /** Nr of log action summaries per action verb */
  nrsPerActionVerb: Array<KeyCount>;
  /** Nr of log action summaries per target type */
  nrsPerTargetType: Array<KeyCount>;
  /** Total nr of log action summaries */
  totalNr: Scalars['Int']['output'];
};

/** Log action summary */
export type LogActionSummary = {
  __typename?: 'LogActionSummary';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Action location */
  app: ActionApp;
  /** Client date */
  clientDate: Scalars['Timestamp']['output'];
  /** Actor login name */
  loginName: Scalars['ID']['output'];
  /** Server date */
  serverDate: Scalars['Timestamp']['output'];
  /** Session sequence number */
  sessionSequenceNumber: Scalars['Int']['output'];
  /** Target type */
  targetType: TargetTypes;
  /** Action verb */
  verb: ActionVerb;
};

export type LogActionTimeQueryInput = {
  /** End time */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start time */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataJson = {
  __typename?: 'MetadataJSON';
  /** Actor */
  actor: Actor;
  /** Flags */
  flags?: Maybe<Scalars['JSON']['output']>;
  /** Generator */
  generator: Generator;
  /** Provider */
  provider: Provider;
  /** Published client date */
  published?: Maybe<Scalars['Timestamp']['output']>;
  /** Published server date */
  publishedServer?: Maybe<Scalars['Timestamp']['output']>;
  /** Target */
  target: Target;
};

export type MetadataJsonInput = {
  /** Actor */
  actor: ActorInput;
  /** Flags */
  flags?: InputMaybe<Scalars['JSON']['input']>;
  /** Generator */
  generator: GeneratorInput;
  /** Provider */
  provider: ProviderInput;
  /** Published client date */
  published?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Published server date */
  publishedServer?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Target */
  target: TargetInput;
};

export type MongoDbVersion = {
  __typename?: 'MongoDbVersion';
  /** MongoDB status */
  ok: Scalars['Float']['output'];
  /** Openssl compiled version */
  openSslCompiledVersion: Scalars['String']['output'];
  /** Openssl running version */
  openSslRunningVersion: Scalars['String']['output'];
  /** Version */
  version: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addArtefactRouteToScienceOrganisation: ArtefactRouteScienceOrganisation;
  addArtefactToScienceOrganisation: ArtefactScienceOrganisation;
  addChildArtefactToArtefact: ChildArtefactArtefact;
  addContentElementToArtefact: ContentElementArtefact;
  addLogAction: LogAction;
  addMembersToScienceOrganisation: ScienceOrganisation;
  addSelfReportToAccount: AccountNewHighscore;
  changePassword: Account;
  createAccount: Account;
  createContentElement: ContentElement;
  createContentPlugin: ContentPlugin;
  createContentState: ContentState;
  createQrCode: QrCode;
  createScienceOrganisation: ScienceOrganisation;
  disableAccount: Account;
  disableArtefact: Artefact;
  disableArtefactRoute: ArtefactRoute;
  disableContentElement: ContentElement;
  disableContentPlugin: ContentPlugin;
  disableNotifications: Account;
  disableScienceOrganisation: ScienceOrganisation;
  duplicateArtefactInScienceOrganisation: ArtefactScienceOrganisation;
  duplicateContentElementInArtefact: ContentElementArtefact;
  enableAccount: Account;
  enableArtefact: Artefact;
  enableArtefactRoute: ArtefactRoute;
  enableContentElement: ContentElement;
  enableContentPlugin: ContentPlugin;
  enableNotifications: Account;
  enableScienceOrganisation: ScienceOrganisation;
  moveArtefactRouteToTrash: ArtefactRoute;
  moveArtefactToTrash: Artefact;
  moveContentElementToTrash: ContentElement;
  moveContentPluginToTrash: ContentPlugin;
  moveScienceOrganisationToTrash: ScienceOrganisation;
  orderArtefactRoutes: Array<ArtefactRoute>;
  orderArtefacts: Array<Artefact>;
  orderContentElements: Array<ContentElement>;
  orderContentPlugins: Array<ContentPlugin>;
  orderScienceOrganisations: Array<ScienceOrganisation>;
  removeArtefact: Artefact;
  removeArtefactRoute: ArtefactRoute;
  removeArtefactsFromScienceOrganisation: ScienceOrganisation;
  removeChildArtefactsFromArtefact: Artefact;
  removeContentElement: ContentElement;
  removeContentElementsFromArtefact: Artefact;
  removeContentPlugin: ContentPlugin;
  removeContentState: ContentState;
  removeMembersFromScienceOrganisation: ScienceOrganisation;
  removeScienceOrganisation: ScienceOrganisation;
  retrieveArtefactFromTrash: Artefact;
  retrieveArtefactRouteFromTrash: ArtefactRoute;
  retrieveContentElementFromTrash: ContentElement;
  retrieveContentPluginFromTrash: ContentPlugin;
  retrieveScienceOrganisationFromTrash: ScienceOrganisation;
  sendActivityReminderToPeopleWhoHaveBeenInactiveForSevenDays: Notification;
  sendActivityReminderToPeopleWhoHaveBeenInactiveForThreeDays: Notification;
  sendGenericActivityReminderToEveryone: Notification;
  sendNotification: Notification;
  sendStreakAboutToExpireToEveryone: Notification;
  sendStreakReminderToEveryone: Notification;
  updateAccount: Account;
  updateArtefact: Artefact;
  updateArtefactRoute: ArtefactRoute;
  updateContentElement: ContentElement;
  updateContentPlugin: ContentPlugin;
  updateContentState: ContentState;
  updateScienceOrganisation: ScienceOrganisation;
};


export type MutationAddArtefactRouteToScienceOrganisationArgs = {
  createArtefactRouteInput: CreateArtefactRouteInput;
  id: Scalars['ID']['input'];
};


export type MutationAddArtefactToScienceOrganisationArgs = {
  createArtefactInput: CreateArtefactInput;
  id: Scalars['ID']['input'];
};


export type MutationAddChildArtefactToArtefactArgs = {
  createArtefactInput: CreateArtefactInput;
  id: Scalars['ID']['input'];
};


export type MutationAddContentElementToArtefactArgs = {
  createContentElementInput: CreateContentElementInput;
  id: Scalars['ID']['input'];
};


export type MutationAddLogActionArgs = {
  addLogActionInput: AddLogActionInput;
};


export type MutationAddMembersToScienceOrganisationArgs = {
  addMembersToScienceOrganisationInput: AddMembersToScienceOrganisationInput;
  id: Scalars['ID']['input'];
};


export type MutationAddSelfReportToAccountArgs = {
  createSelfReportInput: CreateSelfReportInput;
  id: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  changePasswordInput: ChangePasswordInput;
  id: Scalars['ID']['input'];
};


export type MutationCreateAccountArgs = {
  createAccountInput: CreateAccountInput;
};


export type MutationCreateContentElementArgs = {
  createContentElementInput: CreateContentElementInput;
};


export type MutationCreateContentPluginArgs = {
  createContentPluginInput: CreateContentPluginInput;
};


export type MutationCreateContentStateArgs = {
  createContentStateInput: CreateContentStateInput;
};


export type MutationCreateQrCodeArgs = {
  createQrCodeInput: CreateQrCodeInput;
};


export type MutationCreateScienceOrganisationArgs = {
  createScienceOrganisationInput: CreateScienceOrganisationInput;
};


export type MutationDisableAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableNotificationsArgs = {
  dto: EnableNotificationDto;
};


export type MutationDisableScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateArtefactInScienceOrganisationArgs = {
  artefactId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDuplicateContentElementInArtefactArgs = {
  contentElementId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationEnableAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableNotificationsArgs = {
  dto: EnableNotificationDto;
};


export type MutationEnableScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveArtefactRouteToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveArtefactToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveContentElementToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveContentPluginToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveScienceOrganisationToTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderArtefactRoutesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderArtefactsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderContentElementsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderContentPluginsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderScienceOrganisationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveArtefactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveArtefactRouteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveArtefactsFromScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  oldArtefactIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveChildArtefactsFromArtefactArgs = {
  id: Scalars['ID']['input'];
  oldArtefactIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveContentElementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentElementsFromArtefactArgs = {
  id: Scalars['ID']['input'];
  oldContentElementIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveContentPluginArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContentStateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMembersFromScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  removeMembersFromScienceOrganisationInput: RemoveMembersFromScienceOrganisationInput;
};


export type MutationRemoveScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveArtefactFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveArtefactRouteFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveContentElementFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveContentPluginFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetrieveScienceOrganisationFromTrashArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendNotificationArgs = {
  notification: SendNotificationDto;
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  updateAccountInput: UpdateAccountInput;
};


export type MutationUpdateArtefactArgs = {
  id: Scalars['ID']['input'];
  updateArtefactInput: UpdateArtefactInput;
};


export type MutationUpdateArtefactRouteArgs = {
  id: Scalars['ID']['input'];
  updateArtefactRouteInput: UpdateArtefactRouteInput;
};


export type MutationUpdateContentElementArgs = {
  id: Scalars['ID']['input'];
  updateContentElementInput: UpdateContentElementInput;
};


export type MutationUpdateContentPluginArgs = {
  id: Scalars['ID']['input'];
  updateContentPluginInput: UpdateContentPluginInput;
};


export type MutationUpdateContentStateArgs = {
  id: Scalars['ID']['input'];
  updateContentStateInput: UpdateContentStateInput;
};


export type MutationUpdateScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
  updateScienceOrganisationInput: UpdateScienceOrganisationInput;
};

/** New highscore */
export type NewHighScore = {
  __typename?: 'NewHighScore';
  /** New longest streak */
  newLongestStreak: Scalars['Boolean']['output'];
  /** The new streak value, if updated */
  newStreakValue?: Maybe<Scalars['Float']['output']>;
  /** Reported fifty activities */
  reportedFiftyActivities: Scalars['Boolean']['output'];
  /** Reported five activities */
  reportedFiveActivities: Scalars['Boolean']['output'];
  /** Reported one activity */
  reportedOneActivity: Scalars['Boolean']['output'];
  /** Reported one hundred activities */
  reportedOneHundredActivities: Scalars['Boolean']['output'];
  /** Reported ten activities */
  reportedTenActivities: Scalars['Boolean']['output'];
  /** Reported twenty five activities */
  reportedTwentyFiveActivities: Scalars['Boolean']['output'];
  /** Updated streak */
  updatedStreak: Scalars['Boolean']['output'];
};

export enum NextlabVerbs {
  Access = 'access',
  Add = 'add',
  ApplicationStarted = 'application_started',
  ApplicationStopped = 'application_stopped',
  Cancel = 'cancel',
  Change = 'change',
  Clear = 'clear',
  Create = 'create',
  Delete = 'delete',
  New = 'new',
  Open = 'open',
  PhaseChanged = 'phase_changed',
  Receive = 'receive',
  Remove = 'remove',
  Send = 'send',
  Start = 'start',
  Update = 'update'
}

/** notification */
export type Notification = {
  __typename?: 'Notification';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Account ids who received notification */
  accountsWhoReceivedNotifications: Array<Account>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Notification payload */
  payload: NotificationPayload;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Account ids who received notification */
  sentToAccountIds: Array<Scalars['ID']['output']>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Type of notification */
  type: SbsNotificationType;
  /** Url */
  url: Scalars['String']['output'];
};

/** notification payload */
export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  /** Language */
  body: Scalars['String']['output'];
  /** Configuration */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Language */
  icon: Scalars['String']['output'];
  /** Language */
  title: Scalars['String']['output'];
};

/** Nr of accounts */
export type NrOfAccounts = {
  __typename?: 'NrOfAccounts';
  /** Nr of disabled accounts */
  nrOfDisabledAccounts: Scalars['Int']['output'];
  /** Nr of disabled administrators */
  nrOfDisabledAdministrators: Scalars['Int']['output'];
  /** Nr of disabled participants */
  nrOfDisabledParticipants: Scalars['Int']['output'];
  /** Nr of disabled projectMembers */
  nrOfDisabledProjectMembers: Scalars['Int']['output'];
  /** Nr of enabled accounts */
  nrOfEnabledAccounts: Scalars['Int']['output'];
  /** Nr of enabled administrators */
  nrOfEnabledAdministrators: Scalars['Int']['output'];
  /** Nr of enabled participants */
  nrOfEnabledParticipants: Scalars['Int']['output'];
  /** Nr of enabled projectMembers */
  nrOfEnabledProjectMembers: Scalars['Int']['output'];
};

/** Nr of log actions */
export type NrOfLogActions = {
  __typename?: 'NrOfLogActions';
  /** Nr of chaser log actions */
  nrOfChaserLogActions: Scalars['Int']['output'];
  /** Nr of digital toolbox manager log actions */
  nrOfDigitalToolboxManagerLogActions: Scalars['Int']['output'];
  /** Nr of server log actions */
  nrOfServerLogActions: Scalars['Int']['output'];
};

export enum PasswordType {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  Local = 'Local'
}

export type PhaseStructure = {
  __typename?: 'PhaseStructure';
  /** List of global apps */
  apps: Array<AppInfo>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Hidden */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Type */
  type: Scalars['String']['output'];
  /** Visibility level */
  visibilityLevel: Scalars['String']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Id */
  id: Scalars['String']['output'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['output'];
  /** Inquire phase */
  inquiryPhase: Scalars['String']['output'];
  /** Inquire phase id */
  inquiryPhaseId: Scalars['String']['output'];
  /** Inquire phase name */
  inquiryPhaseName: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
  /** Url */
  url: Scalars['String']['output'];
};

export type ProviderInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Id */
  id: Scalars['String']['input'];
  /** Learning analytics enabled */
  ilsHasAngeLA: Scalars['Boolean']['input'];
  /** Inquire phase */
  inquiryPhase: Scalars['String']['input'];
  /** Inquire phase id */
  inquiryPhaseId: Scalars['String']['input'];
  /** Inquire phase name */
  inquiryPhaseName: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
  /** Url */
  url: Scalars['String']['input'];
};

/** QR code */
export type QrCode = {
  __typename?: 'QrCode';
  /** Id */
  _id: Scalars['ID']['output'];
  /** code */
  code: Scalars['String']['output'];
  /** Target Id */
  targetId: Scalars['ID']['output'];
  /** Qr code target type */
  targetType: QrCodeTargetType;
};

/** QR code description */
export type QrCodeDescription = {
  __typename?: 'QrCodeDescription';
  /** Artefact */
  artefact?: Maybe<Artefact>;
  /** Artefact id */
  artefactId?: Maybe<Scalars['ID']['output']>;
  /** ArtefactRoute */
  artefactRoute?: Maybe<ArtefactRoute>;
  /** Artefact route id */
  artefactRouteId?: Maybe<Scalars['ID']['output']>;
  /** ContentElement */
  contentElement?: Maybe<ContentElement>;
  /** Content element id */
  contentElementId?: Maybe<Scalars['ID']['output']>;
  /** Science organisation */
  scienceOrganisation: ScienceOrganisation;
  /** Science organisation id */
  scienceOrganisationId?: Maybe<Scalars['ID']['output']>;
  /** Target type */
  targetType: QrCodeTargetType;
};

export enum QrCodeTargetType {
  Artefact = 'Artefact',
  ArtefactRoute = 'ArtefactRoute',
  ContentElement = 'ContentElement',
  ScienceOrganisation = 'ScienceOrganisation'
}

export type Query = {
  __typename?: 'Query';
  findQrCodeDescription: QrCodeDescription;
  getAccountById: Account;
  getAccountByName: Account;
  getAccounts: Array<Account>;
  getAccountsForScienceOrganisation: Scalars['String']['output'];
  getAllContentElements: Array<ContentElement>;
  getAllContentPlugins: Array<ContentPlugin>;
  getAllContentStates: Array<ContentState>;
  getAllScienceOrganisations: Array<ScienceOrganisation>;
  getAllSelfReports: Array<SelfReport>;
  getAllSelfReportsExcelWithAccountInfo: Scalars['String']['output'];
  getAllTrashedContentElements: Array<ContentElement>;
  getAllTrashedContentPlugins: Array<ContentPlugin>;
  getAllTrashedScienceOrganisations: Array<ScienceOrganisation>;
  getArtefactById: Artefact;
  getArtefactRouteById: ArtefactRoute;
  getCollectionIndices: Array<CollectionIndices>;
  getContentElementById: ContentElement;
  getContentElementState: ContentElementState;
  getContentPluginById: ContentPlugin;
  getContentStateById: ContentState;
  getHighScoreList: Array<HighScoreEntry>;
  getIlsStructure: IlsStructure;
  getIlsStructureJson: IlsStructureJson;
  getLogActionById: LogAction;
  getLogActionKeyCounts: LogActionKeyCounts;
  getLogActionSummaries: LogActionSummaries;
  getLogActionsByQuery: Array<LogAction>;
  getLogActionsByVerbs: Array<LogAction>;
  getMigrations: Array<ChangeLog>;
  getNotificationById: Notification;
  getNotifications: Array<Notification>;
  getNrOfAccounts: NrOfAccounts;
  getNrOfLogActions: NrOfLogActions;
  getScienceOrganisationById: ScienceOrganisation;
  getSelfReportById: SelfReport;
  getServerStatus: ServerStatus;
  getStorageStatusOverview: StorageStatusOverview;
  getUsersWithNotificationsEnabled: Array<Account>;
  queryResources: Array<ResourceJson>;
  queryResourcesJson: ResourceQueryResultJson;
  readResource: ResourceJson;
  readResourceJson: ResourceReadResultJson;
  retrieveActors: Array<Actor>;
  retrieveLogActions: Array<ActivityStreamObject>;
  retrieveLogActionsJson: LogAccessorQueryResultJson;
  updateResource: ResourceJson;
  updateResourceJson: ResourceUpdateResultJson;
};


export type QueryFindQrCodeDescriptionArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetAccountByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAccountByNameArgs = {
  loginName: Scalars['String']['input'];
};


export type QueryGetAccountsArgs = {
  accountQuery?: InputMaybe<AccountQuery>;
};


export type QueryGetAccountsForScienceOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetArtefactByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetArtefactRouteByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentElementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentElementStateArgs = {
  accountId: Scalars['ID']['input'];
  contentElementId: Scalars['ID']['input'];
};


export type QueryGetContentPluginByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContentStateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetHighScoreListArgs = {
  nrOfAccounts: Scalars['Int']['input'];
  sortBy: Scalars['String']['input'];
};


export type QueryGetIlsStructureArgs = {
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryGetIlsStructureJsonArgs = {
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryGetLogActionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLogActionKeyCountsArgs = {
  logActionQuery: LogActionQuery;
};


export type QueryGetLogActionSummariesArgs = {
  logActionSummaryQuery: LogActionQuery;
};


export type QueryGetLogActionsByQueryArgs = {
  lastLogActionId?: InputMaybe<Scalars['String']['input']>;
  logActionSummaryQuery: LogActionQuery;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryGetLogActionsByVerbsArgs = {
  verbs: Array<ActionVerb>;
};


export type QueryGetNotificationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetScienceOrganisationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSelfReportByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQueryResourcesArgs = {
  resourceQueryJSON: ResourceQueryJson;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryQueryResourcesJsonArgs = {
  resourceQueryJSON: ResourceQueryJson;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryReadResourceArgs = {
  resourceId: Scalars['ID']['input'];
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryReadResourceJsonArgs = {
  resourceId: Scalars['ID']['input'];
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryRetrieveLogActionsArgs = {
  logActionProjectionJSONInput: LogActionProjectionJsonInput;
  logActionQueryJSONInput: LogActionQueryJsonInput;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryRetrieveLogActionsJsonArgs = {
  logActionProjectionJSONInput: LogActionProjectionJsonInput;
  logActionQueryJSONInput: LogActionQueryJsonInput;
  scienceOrganisationId: Scalars['ID']['input'];
};


export type QueryUpdateResourceArgs = {
  resource: ResourceJsonInput;
};


export type QueryUpdateResourceJsonArgs = {
  resource: ResourceJsonInput;
};

export type RemoveMembersFromScienceOrganisationInput = {
  /** Old member ids */
  oldMemberIds: Array<Scalars['ID']['input']>;
};

export type ResourceJson = {
  __typename?: 'ResourceJSON';
  /** Content */
  content?: Maybe<Scalars['JSON']['output']>;
  /** Metadata */
  metadata: MetadataJson;
};

export type ResourceJsonInput = {
  /** Content */
  content?: InputMaybe<Scalars['JSON']['input']>;
  /** Metadata */
  metadata: MetadataJsonInput;
};

export type ResourceQueryJson = {
  /** actor id */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** app id */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** max nr of results */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** order by modification date */
  orderByModificationDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** page number */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** resource type */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** return metadata only */
  returnMetadataOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceQueryResultJson = {
  __typename?: 'ResourceQueryResultJson';
  /** resource query results */
  resourceQueryResults: Scalars['JSON']['output'];
};

export type ResourceReadResultJson = {
  __typename?: 'ResourceReadResultJson';
  /** resource read results */
  resourceReadResults: Scalars['JSON']['output'];
};

export type ResourceUpdateResultJson = {
  __typename?: 'ResourceUpdateResultJson';
  /** resource update results */
  resourceUpdateResults: Scalars['JSON']['output'];
};

export enum SbsNotificationType {
  ActivityReminder = 'ACTIVITY_REMINDER',
  ActivityReminderSevenDays = 'ACTIVITY_REMINDER_SEVEN_DAYS',
  ActivityReminderThreeDays = 'ACTIVITY_REMINDER_THREE_DAYS',
  Custom = 'CUSTOM',
  StreakAboutToExpire = 'STREAK_ABOUT_TO_EXPIRE',
  StreakReminder = 'STREAK_REMINDER'
}

/** science organisation */
export type ScienceOrganisation = {
  __typename?: 'ScienceOrganisation';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Artefact ids */
  artefactIds: Array<Scalars['ID']['output']>;
  /** Artefact route ids */
  artefactRouteIds: Array<Scalars['ID']['output']>;
  /** Artefact routes */
  artefactRoutes: Array<ArtefactRoute>;
  /** Artefacts */
  artefacts: Array<Artefact>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** Location */
  location: Location;
  /** Logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Member ids */
  memberIds: Array<Scalars['ID']['output']>;
  /** Members */
  members: Array<Account>;
  /** NotificationIds */
  notificationIds: Array<Scalars['ID']['output']>;
  /** Notifications */
  notifications: Array<Notification>;
  /** QR code string */
  qrCode?: Maybe<Scalars['String']['output']>;
  /** Sequence number */
  sequenceNumber: Scalars['Int']['output'];
  /** Title and descriptions */
  titleAndDescriptions: Array<SingleLanguageTitleDescription>;
  /** Trashed at */
  trashedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Url */
  url: Scalars['String']['output'];
  /** Website url */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Scores */
export type Scores = {
  __typename?: 'Scores';
  /** Current streak */
  currentStreak: Scalars['Int']['output'];
  /** Do */
  doScore: Scalars['Float']['output'];
  /** Longest streak */
  longestStreak: Scalars['Int']['output'];
  /** Read */
  readScore: Scalars['Float']['output'];
  /** Total strand scores */
  strandsScores: Strands;
  /** Visit / attend */
  visitAttendScore: Scalars['Float']['output'];
  /** Watch/listen */
  watchListenScore: Scalars['Float']['output'];
};

/** Self report */
export type SelfReport = {
  __typename?: 'SelfReport';
  /** Id */
  _id: Scalars['ID']['output'];
  /** Content element id */
  contentElementId?: Maybe<Scalars['ID']['output']>;
  /** Created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Creator */
  creator: Account;
  /** Creator id */
  creatorId: Scalars['ID']['output'];
  /** Description of the report */
  description?: Maybe<Scalars['String']['output']>;
  /** Disabled */
  disabled: Scalars['Boolean']['output'];
  /** Created at */
  lastModificationAt: Scalars['Timestamp']['output'];
  /** Last modifier */
  lastModifier: Account;
  /** Creator id */
  lastModifierId: Scalars['ID']['output'];
  /** URL of the report */
  materialUrl?: Maybe<Scalars['String']['output']>;
  /** May be deleted */
  mayBeDeleted: Scalars['Boolean']['output'];
  /** Strands */
  strands: Strands;
  /** Title of the report */
  title: Scalars['String']['output'];
  /** Type of the report */
  type: SelfReportType;
  /** Url */
  url: Scalars['String']['output'];
};

export enum SelfReportType {
  Do = 'Do',
  Read = 'Read',
  VisitAttend = 'VisitAttend',
  WatchListen = 'WatchListen'
}

export type SendNotificationDto = {
  /** Artefact id */
  artefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Notification body */
  body: Scalars['String']['input'];
  /** Content element id */
  contentElementId?: InputMaybe<Scalars['ID']['input']>;
  /** Science organisation id */
  scienceOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  /** Notification title */
  title: Scalars['String']['input'];
};

export type ServerStatus = {
  __typename?: 'ServerStatus';
  /** Average load */
  averageLoad: Array<Scalars['Float']['output']>;
  /** Free disk space */
  freeDiskSpace: Scalars['Int']['output'];
  /** Free memory */
  freeMemory: Scalars['Int']['output'];
  /** Number of cpus */
  nrOfCpus: Scalars['Int']['output'];
  /** OS release */
  osRelease: Scalars['String']['output'];
  /** OS type */
  osType: Scalars['String']['output'];
  /** OS version */
  osVersion: Scalars['String']['output'];
  /** Running */
  running: Scalars['Boolean']['output'];
  /** Total disk space */
  totalDiskSpace: Scalars['Int']['output'];
  /** Total memory */
  totalMemory: Scalars['Int']['output'];
  /** Uptime */
  uptime: Scalars['Int']['output'];
};

/** title and description in one language */
export type SingleLanguageTitleDescription = {
  __typename?: 'SingleLanguageTitleDescription';
  /** Description */
  description: Scalars['String']['output'];
  /** Language */
  language: Scalars['String']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

export type SingleLanguageTitleDescriptionDto = {
  /** Description */
  description: Scalars['String']['input'];
  /** Language */
  language: Scalars['String']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

export type StorageStatusOverview = {
  __typename?: 'StorageStatusOverview';
  /** Collection overviews */
  collectionOverviews: Array<CollectionOverview>;
  /** MongoDb version */
  mongoDbVersion: MongoDbVersion;
};

/** Strands */
export type Strands = {
  __typename?: 'Strands';
  /** I got insight into the scientific work */
  insight: Scalars['Float']['output'];
  /** It was interesting */
  interesting: Scalars['Float']['output'];
  /** I learned something new */
  learned: Scalars['Float']['output'];
  /** I saw myself as a science person */
  sciencePerson: Scalars['Float']['output'];
  /** I used science tools and language */
  scienceToolsAndLanguage: Scalars['Float']['output'];
  /** It helped me understanding something in science */
  understanding: Scalars['Float']['output'];
};

export type StrandsInput = {
  /** I got insight into the scienctific work */
  insight: Scalars['Float']['input'];
  /** It was interesting */
  interesting: Scalars['Float']['input'];
  /** I learned something new */
  learned: Scalars['Float']['input'];
  /** I saw myself as a science person */
  sciencePerson: Scalars['Float']['input'];
  /** I used science tools and language */
  scienceToolsAndLanguage: Scalars['Float']['input'];
  /** It helped me understanding something in science */
  understanding: Scalars['Float']['input'];
};

export type Target = {
  __typename?: 'Target';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** For application (only for configuration resources) */
  forApplication?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['String']['output'];
  /** Object type */
  objectType: Scalars['String']['output'];
};

export type TargetInput = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** For application (only for configuration resources) */
  forApplication?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id: Scalars['String']['input'];
  /** Object type */
  objectType: Scalars['String']['input'];
};

export enum TargetTypes {
  Account = 'Account',
  Artefact = 'Artefact',
  ArtefactRoute = 'ArtefactRoute',
  ContentElement = 'ContentElement',
  ContentPlugin = 'ContentPlugin',
  ContentState = 'ContentState',
  Notification = 'Notification',
  OtherPage = 'OtherPage',
  ScienceOrganisation = 'ScienceOrganisation',
  SelfReport = 'SelfReport',
  Unknown = 'Unknown'
}

export type UpdateAccountInput = {
  /** Accepted legal terms */
  acceptedLegalTerms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account type */
  accountType?: InputMaybe<AccountType>;
  /** Age range */
  ageRange?: InputMaybe<AgeRange>;
  /** Alternative languages */
  alternativeLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Gender>;
  /** Is test account */
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Login name */
  loginName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Password type */
  passwordType?: InputMaybe<PasswordType>;
  /** Preferred language */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Should change password */
  shouldChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateArtefactInput = {
  /** Age ranges */
  ageRanges?: InputMaybe<Array<AgeRange>>;
  /** Child artefact ids */
  childArtefactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Content element ids */
  contentElementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Domains */
  domains?: InputMaybe<Array<Domain>>;
  /** Parent artefact id */
  parentArtefactId?: InputMaybe<Scalars['ID']['input']>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
};

export type UpdateArtefactRouteInput = {
  /** Artefact ids */
  artefactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
};

export type UpdateContentElementInput = {
  /** Age ranges */
  ageRanges?: InputMaybe<Array<AgeRange>>;
  /** At Home */
  atHome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Content id */
  contentId?: InputMaybe<Scalars['String']['input']>;
  /** Content plugin id */
  contentPluginId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** During visit */
  duringVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Feedback body */
  feedbackBody?: InputMaybe<Scalars['String']['input']>;
  /** Feedback title */
  feedbackTitle?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Self report type */
  selfReportType?: InputMaybe<SelfReportType>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentPluginInput = {
  /** Application name */
  applicationName?: InputMaybe<Scalars['String']['input']>;
  /** Editor url */
  editorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
  /** Use in chaser */
  useInChaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use in results */
  useInResults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Viewer url */
  viewerUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentStateInput = {
  /** State */
  state: Scalars['JSON']['input'];
};

export type UpdateScienceOrganisationInput = {
  /** Artefact route ids */
  artefactRouteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Location */
  location?: InputMaybe<LocationDto>;
  /** Logo url */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Member ids */
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notification ids */
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Title and descriptions */
  titleAndDescriptions?: InputMaybe<Array<SingleLanguageTitleDescriptionDto>>;
  /** Website url */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AddLogActionMutationVariables = Exact<{
  sessionSequenceNumber: Scalars['Int']['input'];
  actorId: Scalars['ID']['input'];
  clientDate: Scalars['Timestamp']['input'];
  app: ActionApp;
  verb: ActionVerb;
  targetType: TargetTypes;
  targetId: Scalars['ID']['input'];
  description: Scalars['JSON']['input'];
}>;


export type AddLogActionMutation = { __typename?: 'Mutation', addLogAction: { __typename?: 'LogAction', _id: string } };

export type FindQrCodeDescriptionQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type FindQrCodeDescriptionQuery = { __typename?: 'Query', findQrCodeDescription: { __typename?: 'QrCodeDescription', targetType: QrCodeTargetType, artefactId?: string | null, contentElementId?: string | null, scienceOrganisationId?: string | null, artefactRouteId?: string | null, scienceOrganisation: { __typename?: 'ScienceOrganisation', _id: string, logoUrl?: string | null, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> }, artefact?: { __typename?: 'Artefact', _id: string, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> } | null, contentElement?: { __typename?: 'ContentElement', _id: string, title: string } | null, artefactRoute?: { __typename?: 'ArtefactRoute', _id: string, titleAndDescriptions: Array<{ __typename?: 'SingleLanguageTitleDescription', language: string, title: string }> } | null } };

export const AddLogActionDocument = gql`
    mutation addLogAction($sessionSequenceNumber: Int!, $actorId: ID!, $clientDate: Timestamp!, $app: ActionApp!, $verb: ActionVerb!, $targetType: TargetTypes!, $targetId: ID!, $description: JSON!) {
  addLogAction(
    addLogActionInput: {sessionSequenceNumber: $sessionSequenceNumber, actorId: $actorId, clientDate: $clientDate, app: $app, verb: $verb, targetType: $targetType, targetId: $targetId, description: $description}
  ) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLogActionGQL extends Apollo.Mutation<AddLogActionMutation, AddLogActionMutationVariables> {
    document = AddLogActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindQrCodeDescriptionDocument = gql`
    query findQrCodeDescription($code: String!) {
  findQrCodeDescription(code: $code) {
    targetType
    artefactId
    contentElementId
    scienceOrganisationId
    scienceOrganisation {
      _id
      titleAndDescriptions {
        language
        title
      }
      logoUrl
    }
    artefact {
      _id
      titleAndDescriptions {
        language
        title
      }
    }
    contentElement {
      _id
      title
    }
    artefactRouteId
    artefactRoute {
      _id
      titleAndDescriptions {
        language
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindQrCodeDescriptionGQL extends Apollo.Query<FindQrCodeDescriptionQuery, FindQrCodeDescriptionQueryVariables> {
    document = FindQrCodeDescriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }